<template>
  <div class="trust-chart" :style="trustStyles">
    <div class="trust-chart-center" :style="backGround"><div class="trust-title">TRUST</div><div class="trust-score">{{showTrust}}</div></div>
  </div>
</template>

<script>
export default {
  name: "TrustChart",
  props: ["trust_data", "center_color"],
  computed: {
    showTrust(){
      if(this.trust_data<=0){
          return '0'
      }
      else if(this.trust_data>100){
          return '100+'
      }
      else{
        return this.trust_data
      }  
    },  
    backGround(){
      return {
          background: this.center_color
      }  
    },  
    trustStyles() {
      let trustScore = this.trust_data  
      if(trustScore<=0){
          trustScore = 1
      }
      if(trustScore>100){
          trustScore = 100
      }
      let trustColor;
      let trustValue = (360/100*trustScore);
      let restValue = (360/100*(100-trustValue));
      let restColor = '#ececec';


             if (trustScore < 25) {
               trustColor = '#ff0000'
             } else if (trustScore <50){
               trustColor = '#FAAB19'
             } else if (trustScore <75){
               trustColor = '#320BF5'
             } else {
               trustColor = '#06C72B'
             }
      

      //let styles = this.trustData.map(
      //  segment => `${segment.color} 0 ${(acum += segment.value)}%`
      //);

      return {
        background: 'conic-gradient(from -90deg, '+trustColor+' 0deg,'+trustColor+' '+trustValue+'deg, '+restColor+' '+trustValue+'deg, '+restColor+' '+restValue+'deg )'
      };
    }
  }
};
</script>

<style scoped>
.trust-chart {
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  height:90%;
  position: relative;
  margin-right:10%;
}
.trust-chart-center{
  position:absolute;
  width:80%;
  height:80%;
  border-radius:50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.trust-title,.trust-score{
  display:flex;
  align-items:center;
  justify-content:center;
  font-family: trebuchet ms, arial, sans-serif;
}
.trust-title{
    width:100%;
    height:50%;
    font-size:1.2rem;
    margin-top: 5%;
}
.trust-score{
    font-size: 2rem;
    line-height: 50%;
}

@media (min-width: 768px) { 
 .trust-chart {   
  left: 10%;
  margin-right:0;
 }
}
</style>
